import styled, { css } from 'styled-components';

export const flex = css`
  display: flex;
`;

export const Flex = styled.div`
  ${flex};
`;
